import { FormDoc } from "./form-doc";

export class FormFolder {
  id: number;
  name: string;
  forms: FormDoc[];
  checked?: boolean;
}
